"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("../context");
const styles_1 = require("../styles");
const ImageCheckbox = ({ item, onToggle }) => {
    const { checkList, toggleItem } = (0, react_1.useContext)(context_1.ExpiredContext);
    const isChecked = checkList[item.product_id];
    const toggleChecked = () => {
        onToggle(!isChecked);
        toggleItem(item.product_id);
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.ImageCheckContainer, { isChecked: isChecked, onClick: toggleChecked, children: [(0, jsx_runtime_1.jsx)(styles_1.Image, { draggable: false, src: item.image, isChecked: isChecked }), (0, jsx_runtime_1.jsx)(styles_1.Checkbox, { isChecked: isChecked, children: (0, jsx_runtime_1.jsx)(styles_1.Checkmark, {}) })] }));
};
exports.default = ImageCheckbox;
